export * from './lib/vdc-dialog.service';
export * from './lib/vdc-error-dialog/vdc-error-dialog.component';
export * from './lib/vdc-loading-dialog/vdc-loading-dialog.component';
export * from './lib/client-services-vdc-dialogs.module';
export * from './lib/confirmation-dialog-params';
